<div class="flex flex-col items-center w-full">
  <div class="flex w-full h-2 rounded-full overflow-hidden">
    @for (color of colors(); track color) {
      <div class="flex-1 h-full" [style.backgroundColor]="color"></div>
    }
  </div>
  <div class="flex justify-between w-full mt-1">
    @if (minValue() || maxValue()) {
      <div class="text-sm max-w-[40%] break-words">
        {{ minValue() }}
      </div>
      <div class="text-sm max-w-[40%] text-right break-words">
        {{ maxValue() }}
      </div>
    }
  </div>
</div>
